export default __webpack_public_path__ + "static/media/tommyXTimberlandLogo.277a66b1.png";